export default __webpack_public_path__ + "static/media/song.748d7d18.mp3";